import React from 'react';
import { IconExclamationTriangle } from '../ui-kit/icons';
import { worstLevel, worstLevelBackground, getWarningLevelsFromAvailabilityRequirements } from '../../utils/colors';
import DetailsPopover from './DetailsPopover';
import { Badge } from '../ui-kit';
import { isEmpty } from 'lodash';

const StationName = props => {
  const { group } = props;
  const warningLevels = getWarningLevelsFromAvailabilityRequirements(
    props.group.availability_requirements,
    props.availabilityRequirementState
  );

  if (warningLevels.length === 0) return null;

  const backgroundColor = worstLevelBackground(warningLevels);

  const groupName = group.short_code ? group.short_code : group.name;

  const warningIconColor = worstLevel(warningLevels) === 'on_required' ? 'text-danger' : 'text-warning';

  return (
    <DetailsPopover
      key={props.group.id}
      groupName={groupName}
      availabilityRequirements={group.availability_requirements}
      availabilityRequirementState={props.availabilityRequirementState}
      skills={props.skills}
      incidents={props.incidents}
      showIncidents={props.showIncidents}
    >
      <div className="station-warnings">
        <h3>
          <a href={`/groups/${props.group.id}`} target="_blank" rel="noreferrer">
            <Badge className="pt-2" color={backgroundColor}>
              {!isEmpty(props.incidents) && props.showIncidents && (
                <IconExclamationTriangle className={`fa-beat-fade d-inline-block me-1 ${warningIconColor}`} />
              )}
              {groupName}
            </Badge>
          </a>
        </h3>
      </div>
    </DetailsPopover>
  );
};

export default StationName;
